import { useCallback } from 'react'

import {
	useSetStoreCustomerInfo,
	useSetStoreCustomerInfoError,
} from './data'
import { fetchRevenueCatCustomerInfo } from './revenueCat'

export const useRefreshStoreCustomerInfo = (id: UserId) => {
	const setStoreCustomerInfo = useSetStoreCustomerInfo(id)
	const setStoreCustomerInfoError = useSetStoreCustomerInfoError(id)

	return useCallback(async () => {
		if (!id) {
			return null
		}

		try {
			setStoreCustomerInfoError(null)
			const customerInfo = await fetchRevenueCatCustomerInfo(id)
			console.log("RevenueCat customer info", id, customerInfo)
			setStoreCustomerInfo(customerInfo)
			return customerInfo
		} catch (err) {
			console.error('RevenueCat customer info error', id, err)
			setStoreCustomerInfoError(String(err))
			return null
		}
	}, [ id, setStoreCustomerInfo, setStoreCustomerInfoError ])
}
